/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilterMetal_searchBrowse$ref: FragmentReference;
export type SbSharedRefineMenuFilterMetal_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuMultiSelectSearch_searchBrowse$ref,
  +$refType: SbSharedRefineMenuFilterMetal_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterMetal_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd57dba6fc85e74bb70779a633d1df587';
module.exports = node;
